export const siteInfo = {
  name: "15黑料网",
  shortName: "15HL",
  slogan: "把散落各处的瓜料线索，整理成一条能搜得到的索引",
  intro:
    "15黑料网是一个以关键词为核心的内容检索站。我们不生产话题，也不替任何人下结论，只做一件事：把社交平台上零散的讨论、时间线、回应与后续整理成结构化词条，让你输入一个人名或事件名，就能快速定位到对应汇总。",
  email: "contact@15heiliao.example",
  since: "2023",
  stats: [
    { label: "收录词条", value: "12,486", suffix: "+" },
    { label: "热门黑料词", value: "3,208", suffix: "+" },
    { label: "主题分类", value: "6", suffix: "类" },
    { label: "每日更新", value: "150", suffix: "+" },
  ],
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "热门索引", path: "/keywords" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
];

export const principles = [
  {
    icon: "ri-links-line",
    title: "只做索引，不做定论",
    desc: "词条只呈现已公开的讨论线索与时间顺序，不添加立场判断，也不替事件下结论。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新，标注时间",
    desc: "每个词条保留首次整理时间与最近更新日期，方便你判断信息的新旧程度。",
  },
  {
    icon: "ri-shield-check-line",
    title: "不收录隐私信息",
    desc: "不展示证件、住址、联系方式等个人隐私内容，不提供任何未经公开的私人资料。",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "标注来源类别",
    desc: "汇总时区分「当事人回应」「媒体转述」「网友讨论」，帮你看清信息来自哪一层。",
  },
];

export const testimonials = [
  {
    name: "追瓜不改名",
    role: "常驻用户",
    content: "以前看到一半的话题想补前面发生了什么，得翻好几页微博。这里搜一下就能看到时间线，省事。",
  },
  {
    name: "夜航西飞",
    role: "内容运营",
    content: "索引页的拼音分组很实用，做选题的时候按分类扫一遍，能快速知道最近哪类话题在起量。",
  },
  {
    name: "小满不吃瓜",
    role: "普通用户",
    content: "喜欢它把「回应」单独列出来的做法，很多地方只写爆料不写后续，看完容易一头雾水。",
  },
];